import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigureAmplify } from 'config/amplify_config';
import { HelmetProvider } from 'react-helmet-async';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux';
import { store } from 'redux/store';
import { postActivityLog } from 'services/generalServices';
import ErrorFallback from 'components/ErrorFallback/ErrorFallback';

import 'bootstrap/dist/css/bootstrap.css';
import 'assets/scss/index.scss';
import 'assets/scss/style.scss';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'assets/scss/toggle.scss';
import '@fonticonpicker/react-fonticonpicker/dist/fonticonpicker.base-theme.react.css';
import '@fonticonpicker/react-fonticonpicker/dist/fonticonpicker.material-theme.react.css';
import 'react-tagsinput/react-tagsinput.css';

/**
 * Amplify Configuration
 */
ConfigureAmplify();

/**
 * Get browser and device information for logging
 */
const getBrowserInfo = () => ({
  userAgent: navigator?.userAgent,
  language: navigator?.language,
  cookiesEnabled: navigator?.cookieEnabled,
  online: navigator?.onLine,
  screenResolution: `${window?.screen?.width}x${window?.screen?.height}`,
  viewportSize: `${window?.innerWidth}x${window?.innerHeight}`,
  isTouchDevice: navigator?.maxTouchPoints > 0 || navigator?.msMaxTouchPoints > 0,
});

const logError = (error, errorInfo) => {
  postActivityLog(
    {
      event_items: {
        message: error?.message,
        stack: error?.stack,
        componentStack: errorInfo?.componentStack,
        location: window.location.href,
        browser: getBrowserInfo(),
      },
      event_type: 'frontend_crash',
    },
    true
  );
};

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={(error, info) => logError(error, info)}>
      <HelmetProvider>
        <Provider store={store}>
          <App />
        </Provider>
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>,

  document.getElementById('root')
);
reportWebVitals();
